export const API_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/sal-committee`;

export const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Error text from a failed response — the JSON `message` when there is one,
// otherwise the raw body.
export const readErrorMessage = async (response) => {
  const text = await response.text();
  let message = text;
  try {
    message = JSON.parse(text).message || text;
  } catch {
    // keep raw text
  }
  return message || `שגיאה (${response.status})`;
};
